<template>
  <BaseModal
    :id="id"
    :modalClass="`modal-sm`"
    :showCloseButton="true"
    :showFooter="false"
    :headerText="$t('apps.payment.message.paywithpromptpay')"
  >
    <template #body>
      <div class="wrapper">
        <img :src="qrCodeUri">
        <p>
          {{ $t('apps.payment.message.pleasewaitforamomentafterfinishedthepayment') }}
        </p>
      </div>
    </template>
  </BaseModal>
</template>

<script>

export default {
  props: {
    id: String,
    qrCodeUri: String,
  },

  data () {
    return {

    }
  },
}
</script>

<style scoped>
  .wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .wrapper img {
    width: 200px;
  }
  .wrapper p {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/base/BaseModalScanPayment.vue